import { useEffect, useState } from 'react';

/**
 * Returns `true` iff the viewport is at least `minWidthPx` wide. SSR-safe
 * (returns `false` when `window` is unavailable). Updates on resize.
 *
 * Use this to drive the `railsVisible` prop on `SceneLayout`.
 */
export function useViewportAtLeast(minWidthPx: number): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(`(min-width: ${minWidthPx}px)`).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia(`(min-width: ${minWidthPx}px)`);
    const update = () => setMatches(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, [minWidthPx]);

  return matches;
}
